"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleContainer = exports.TaggstarWrapper = exports.TaggstarContainer = exports.StyledSaveForLater = exports.StyledProductcard = exports.StyledPrice = exports.SpaceUnderImage = exports.CardContainer = exports.BrandContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _index = require("../../fuse-price/src/index");
var _grid = require("../../fuse-responsive-grid/src/grid");
var _save = require("../../fuse-save/src/save");
var _typography = require("../../fuse-typography-element/src/typography");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var CardContainer = exports.CardContainer = _styledComponents["default"].div.attrs({
  className: 'fuse-complex-product-card'
}).withConfig({
  displayName: "styled-product-card__CardContainer",
  componentId: "sc-10upnvu-0"
})(["width:100%;min-width:100%;position:relative;"]);
var StyledProductcard = exports.StyledProductcard = _styledComponents["default"].a.attrs({
  className: 'fuse-complex-product-card__link',
  'data-testid': 'fuse-complex-product-card__link'
}).withConfig({
  displayName: "styled-product-card__StyledProductcard",
  componentId: "sc-10upnvu-1"
})(["display:inline-flex;position:relative;flex-direction:column;width:100%;min-width:0;text-decoration:none;&:focus-visible{outline:var(--border-width-s) solid var(--color-functional-focus);}&:focus:not(:focus-visible){outline:none;}"]);
var BrandContainer = exports.BrandContainer = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-complex-product-card__brand',
  'data-testid': 'fuse-complex-product-card__brand'
}).withConfig({
  displayName: "styled-product-card__BrandContainer",
  componentId: "sc-10upnvu-2"
})(["margin-bottom:var(--spacing-global-space2);min-height:calc(var(--font-size-1) + 4px);display:block;max-width:100%;text-overflow:ellipsis;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;"]);
var TitleContainer = exports.TitleContainer = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-complex-product-card__title',
  'data-testid': 'fuse-complex-product-card__title'
}).withConfig({
  displayName: "styled-product-card__TitleContainer",
  componentId: "sc-10upnvu-3"
})(["display:block;margin:0 0 var(--spacing-global-space3);overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;"]);
var StyledPrice = exports.StyledPrice = (0, _styledComponents["default"])(_index.Price).attrs({
  className: 'fuse-complex-product-card__price',
  'data-testid': 'fuse-complex-product-card__price'
}).withConfig({
  displayName: "styled-product-card__StyledPrice",
  componentId: "sc-10upnvu-4"
})(["margin:0 0 var(--spacing-global-space3);"]);
var StyledSaveForLater = exports.StyledSaveForLater = (0, _styledComponents["default"])(_save.Save).attrs({
  className: 'fuse-complex-product-card__save-for-later',
  'data-testid': 'fuse-complex-product-card__save-for-later',
  'data-cnstrc-btn': 'add_to_wishlist'
}).withConfig({
  displayName: "styled-product-card__StyledSaveForLater",
  componentId: "sc-10upnvu-5"
})(["position:absolute;padding:var(--spacing-global-space2);top:5px;right:5px;@media only screen and (min-width:", "){top:9px;right:9px;}@media only screen and (min-width:", "){top:13px;right:13px;}"], _grid.gridConfig.m.minWidth, _grid.gridConfig.l.minWidth);
var TaggstarWrapper = exports.TaggstarWrapper = _styledComponents["default"].div.attrs({
  className: 'productInfo'
}).withConfig({
  displayName: "styled-product-card__TaggstarWrapper",
  componentId: "sc-10upnvu-6"
})([""]);
var TaggstarContainer = exports.TaggstarContainer = _styledComponents["default"].div.attrs({
  className: 'persuasive-message'
}).withConfig({
  displayName: "styled-product-card__TaggstarContainer",
  componentId: "sc-10upnvu-7"
})([""]);
var SpaceUnderImage = exports.SpaceUnderImage = _styledComponents["default"].div.withConfig({
  displayName: "styled-product-card__SpaceUnderImage",
  componentId: "sc-10upnvu-8"
})(["height:var(--spacing-global-space5);"]);